export default "/images/dansk_boligforsikring.avif?c2d4b448f273cee4bdc3dfec3c549259";